// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"164db8ea","132":"7c05878c","241":"a74d2e56","418":"565b3340","462":"27ea6c2a","692":"637435c5","862":"f356cef8","873":"a881e8e7","895":"65616c92","970":"8b1ba392"}[chunkId] + ".chunk.js";
};